module.exports = __webpack_public_path__ + "static/media/empty-card.a1692a1b.svg";